import React, { ReactNode } from 'react';
import { Avatar, makeStyles, Box, Popover } from '@material-ui/core';
import { FruitPropsType } from 'src/views/harvesting/fruit-profile/model';
import Skeleton from '@material-ui/lab/Skeleton';
interface SmartAvatarType {
  fruit: FruitPropsType;
}

export const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: 'none',
    background: 'transparent',
  },
  paper: {
    //   padding: theme.spacing(1),
    marginLeft: theme.spacing(1),
    background: 'transparent',
    borderRadius: 500,
  },
  avatar: {
    width: theme.spacing(8.5),
    height: theme.spacing(8.5),
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
  },
  zoomAvatar: {
    width: theme.spacing(22),
    height: theme.spacing(22),
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(14),
      height: theme.spacing(14),
    },
  },
  smallAvatar: {},
}));

export const SmartAvatar: React.FC<SmartAvatarType> = ({ fruit }) => {
  const classes = useStyles();
  // if(fruit)
  if (
    fruit.platform === 'Instagram' &&
    fruit.image &&
    !fruit.image?.includes('combine')
  ) {
    return (
      <Skeleton animation='wave' variant='circle' className={classes.avatar} />
    );
  }
  return (
    <FishProfilePopUpZoom
      zoomPic={
        <Avatar
          alt={fruit.name}
          src={imageLink(fruit)}
          className={classes.zoomAvatar}
        />
      }
    >
      <Avatar
        alt={fruit.name}
        src={imageLink(fruit)}
        className={classes.avatar}
      />
    </FishProfilePopUpZoom>
  );
};

function imageLink(fruit: FruitPropsType) {
  return !!fruit.image && fruit.image !== ''
    ? fruit.image
    : `https://icotar.com/initials/${fruit.name}`;
}

interface FFishProfilePopUpZoomType {
  zoomPic: ReactNode;
  children: React.ReactNode;
}
export const FishProfilePopUpZoom: React.FC<FFishProfilePopUpZoomType> = ({
  children,
  zoomPic,
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <Box
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup='true'
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        {children}
      </Box>

      <Popover
        id='mouse-over-popover'
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        {zoomPic}
      </Popover>
    </div>
  );
};
